<template lang="pug">
  .container
    .columns.is-vcentered
      .column.is-offset-1.is-6
        .field
          label.label Nombre del Cruce
            .control.has-icons-left.has-icons-right
              input.input.is-dark(
                type='text', 
                placeholder='Nombre del Cruce',
                v-model="nombre",
              )
      .column.is-offset-2.is-2
        a.button.is-block.is-black.is-rounded(@click="checkForm")
          | Guardar Cruce
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .column.is-12
        .notification
          button.delete(@click="deleteNotificacion")
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
</template>

<script>
  export default {
    name: 'FormCruce',
    components: {
    },
    props: {
      cruce: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        isLoading: false,
        isDisabled: false,
        nombre: '',
        datosFaltantes: [],
      }
    },
    methods: {
      iniciarComponente () {
      },
      checkForm () {
        this.datosFaltantes = []
        if (this.nombre) {
          this.saveForm()
        } else {
          if (!this.nombre) {
            this.datosFaltantes.push('El Nombre es requerido.')
          }
        }
      },
      saveForm () {
        const myObj = {
          nombre: this.nombre,
        }
        this.$emit('saveForm', myObj)
      },

      deleteNotificacion () {
        this.datosFaltantes = []
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/cruces/FormCruce.vue